module.exports = __webpack_public_path__ + "static/img/10.1b8685c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zeus/10.png
// module id = OIYm
// module chunks = 0